import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossedOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="m15.5 14.5-1 1-2.368-2.368c-.076.272-.18.478-.323.63-.521.556-1.254.068-2.72-.908L6.98 11.451q-.36-.24-.682-.456-.144.002-.3.002c-2.624 0-2.998-.375-2.998-3 0-1.815.18-2.554 1.16-2.837L.5 1.5l1-1zm-4.606-2.606L5.408 6.408c-.32.011-.552.033-.726.066-.08.015-.132.03-.166.04a1 1 0 0 0-.041.167c-.05.267-.075.672-.075 1.317s.025 1.05.075 1.316q.024.118.04.167.05.018.167.04c.267.051.671.076 1.317.076q.147 0 .28-.002l.438-.005.363.244q.315.212.676.452l2.108 1.403c.373.248.671.446.929.605l.064.04.014-.138q.014-.142.023-.302"
                        fill="currentColor"
                    />
                    <path
                        d="M12.33 9.33V6.595c0-2.538 0-3.807-.52-4.362-.522-.556-1.255-.067-2.722.909L7.32 4.319l1.01 1.01 1.535-1.022c.373-.248.671-.446.929-.605l.064-.04q.008.064.014.137c.058.624.06 1.498.06 2.796V7.93z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
SpeakerCrossedOutlinedSize16Glyph.displayName = 'SpeakerCrossedOutlinedSize16Glyph';
